/**
 * Global loading-button behavior.
 *
 * Opt in by adding `data-loading-button` to any <button> or <a>. On click the
 * element gets `is-loading` (+ `aria-busy`); shared CSS (spv-shared.css) hides
 * its children and shows a centered spinner via `::after`.
 *
 * Auto-resets on cart update/error events, on bfcache restore (pageshow), and
 * via a per-click safety timeout. Buttons that navigate away (e.g. checkout)
 * stay loading until the page changes.
 */
(function () {
  if (window.__spvLoadingButton) return;
  window.__spvLoadingButton = true;

  var SAFETY_MS = 8000;

  function setLoading(el, on) {
    if (!el) return;
    el.classList.toggle('is-loading', on);
    if (on) {
      el.setAttribute('aria-busy', 'true');
    } else {
      el.removeAttribute('aria-busy');
    }
  }

  function resetAll() {
    var loading = document.querySelectorAll('[data-loading-button].is-loading');
    for (var i = 0; i < loading.length; i++) setLoading(loading[i], false);
  }

  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest('[data-loading-button]');
      if (!button) return;
      if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;
      setLoading(button, true);
      setTimeout(function () {
        setLoading(button, false);
      }, SAFETY_MS);
    },
    true
  );

  // `cart:update` fires after a successful add/qty change; `cart:error` on failure.
  document.addEventListener('cart:update', resetAll);
  document.addEventListener('cart:error', resetAll);
  window.addEventListener('pageshow', resetAll);
})();
